// extracted by mini-css-extract-plugin
module.exports = {"dialog":"XIb106ksPcdKHWdxy2hm8","subHeader":"_35bhY9oiszo5Y2KkwOKIdI","group":"_3ZYP90EeY2OHBtHqpTGyNY","groupItem":"_9vcERs-ZYqzSoYirHPRcA","another":"_3qa2mszxfn0bXOQ0nEq9o9"};